var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-head"},[_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.itemSpecs')))]),_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.qty')))]),_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.price')))]),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }